<div class="flex flex-col gap-3">
  <p-toast></p-toast>
  <p-confirmdialog />

  <div class="flex justify-between items-center">
    <h3 class="text-base font-semibold m-0">
      {{ 'catalog.prices.historyTitle' | translate }}
    </h3>
    @if (!formVisible()) {
      <p-button
        size="small"
        icon="fa fa-plus"
        [label]="'catalog.prices.addNew' | translate"
        (onClick)="showForm()"
      />
    }
  </div>

  @if (formVisible()) {
    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="grid grid-cols-1 md:grid-cols-4 gap-3 p-3 border rounded surface-border"
    >
      <div class="flex flex-col">
        <label class="text-sm mb-1">{{ 'catalog.prices.validFrom' | translate }}</label>
        <p-datepicker
          formControlName="valid_from"
          dateFormat="dd.mm.yy"
          appendTo="body"
        />
      </div>
      <div class="flex flex-col">
        <label class="text-sm mb-1">{{ 'catalog.prices.price' | translate }}</label>
        <p-inputnumber
          formControlName="price"
          mode="currency"
          currency="EUR"
          locale="de-DE"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
        />
        @if (netPriceFormatted(); as net) {
          <small class="text-xs text-color-secondary mt-1">
            {{ 'catalog.prices.priceNetHint' | translate: { net } }}
          </small>
        }
      </div>
      <div class="flex flex-col">
        <label class="text-sm mb-1">{{ 'catalog.prices.tax' | translate }}</label>
        <p-inputnumber
          formControlName="taxPercent"
          suffix=" %"
          [minFractionDigits]="0"
          [maxFractionDigits]="2"
          [min]="0"
          [max]="100"
        />
      </div>
      <div class="flex items-end gap-2">
        <p-button
          type="submit"
          size="small"
          [label]="'catalog.prices.save' | translate"
          [loading]="submitting()"
          [disabled]="form.invalid"
        />
        <p-button
          type="button"
          size="small"
          severity="secondary"
          [label]="'catalog.prices.cancel' | translate"
          (onClick)="hideForm()"
        />
      </div>
    </form>
  }

  @if (sortedPrices().length === 0) {
    <p class="text-sm text-color-secondary italic">
      {{ 'catalog.prices.noEntries' | translate }}
    </p>
  } @else {
    <p-table [value]="sortedPrices()" styleClass="p-datatable-sm" dataKey="id">
      <ng-template #header>
        <tr>
          <th>{{ 'catalog.prices.validFrom' | translate }}</th>
          <th class="text-right">{{ 'catalog.prices.price' | translate }}</th>
          <th class="text-right">{{ 'catalog.prices.tax' | translate }}</th>
          <th></th>
          <th class="w-20"></th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.valid_from | date: 'dd.MM.yyyy' : 'Europe/Berlin' }}</td>
          <td class="text-right">
            {{ row.price | number: '1.2-2' : 'de-DE' }} €
          </td>
          <td class="text-right">
            {{ row.tax !== null && row.tax !== undefined ? (((+row.tax) * 100) | number: '1.0-2' : 'de-DE') + ' %' : '—' }}
          </td>
          <td>
            @if (isCurrent(row)) {
              <p-tag
                severity="success"
                [value]="'catalog.prices.current' | translate"
              />
            }
          </td>
          <td class="text-right">
            <button
              pButton
              type="button"
              icon="fa fa-trash"
              text
              rounded
              severity="secondary"
              (click)="onDelete(row, $event)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
